import PageDefault, { ContentMenuItem } from "components/PageDefault";
import Category from './Category'
import BudgetType from "./BudgetType";
import PaymentMethod from "./PaymentMethod";

export default function Info() {
  return (
    <PageDefault title="Infos">
      <PageDefault.Title>Infos</PageDefault.Title>
      <PageDefault.ContentMenu>
        <ContentMenuItem 
          component={Category}
          title="Categoria"
        />
        <ContentMenuItem 
          component={BudgetType}
          title="Tipos de Verba"
        />
        <ContentMenuItem 
          component={PaymentMethod}
          title="Tipos de Pagamento"
        />
      </PageDefault.ContentMenu>
    </PageDefault>
  )
}